/* ==========================================================================
   Royal Care Professional — certification discs

   Two jobs:

   1. Reveal the row once, in sequence. One IntersectionObserver per section
      toggles a single class and then disconnects; the stagger itself is a CSS
      transition-delay, so nothing runs per frame.
   2. Open the matching panel in the section's <dialog>.

   The dialog is native, so focus trapping, ESC, inert background and the top
   layer all come from the browser. The only fallback here is for engines
   without showModal(), where the panel opens inline as a plain overlay.

   Idempotent — init() claims nodes once, so the theme editor can re-run it.
   ========================================================================== */

(function () {
  'use strict';

  if (window.RCCerts) {
    window.RCCerts.init();
    return;
  }

  /* ---- reveal -------------------------------------------------------- */

  function reveal(grid) {
    // No observer, no reveal: the row is already visible without is-armed.
    if (!('IntersectionObserver' in window)) return;

    // Arm first, observe second, so the hidden state only ever exists when
    // something is guaranteed to lift it again.
    grid.classList.add('is-armed');

    var observer = new IntersectionObserver(
      function (entries) {
        if (!entries[0].isIntersecting) return;
        grid.classList.add('is-in');
        observer.disconnect();
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
    );

    observer.observe(grid);
  }

  /* ---- modal --------------------------------------------------------- */

  function Modal(dialog) {
    this.dialog = dialog;
    this.panels = Array.prototype.slice.call(dialog.querySelectorAll('[data-rc-cert-panel]'));
    this.opener = null;
  }

  Modal.prototype.open = function (key, opener) {
    this.opener = opener || null;

    this.panels.forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-rc-cert-panel') !== key;
    });

    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
      this.dialog.classList.add('is-fallback');
    }
  };

  Modal.prototype.close = function () {
    if (typeof this.dialog.close === 'function' && this.dialog.open) {
      this.dialog.close();
    } else {
      this.dialog.removeAttribute('open');
      this.dialog.classList.remove('is-fallback');
    }
  };

  Modal.prototype.mount = function () {
    var self = this;

    // Clicking the backdrop lands on the dialog itself, never on the card.
    this.dialog.addEventListener('click', function (event) {
      if (event.target === self.dialog) self.close();
    });

    Array.prototype.forEach.call(this.dialog.querySelectorAll('[data-rc-cert-close]'), function (button) {
      button.addEventListener('click', function () {
        self.close();
      });
    });

    // Covers both the close button and ESC, so focus always comes home.
    this.dialog.addEventListener('close', function () {
      if (self.opener) self.opener.focus();
      self.opener = null;
    });
  };

  /* ---- boot ---------------------------------------------------------- */

  function init(scope) {
    var root = scope || document;

    Array.prototype.forEach.call(root.querySelectorAll('[data-rc-certs]'), function (section) {
      if (section.dataset.rcInit === 'true') return;
      section.dataset.rcInit = 'true';

      var grid = section.querySelector('[data-rc-certs-grid]');
      if (grid) reveal(grid);

      var dialog = section.querySelector('[data-rc-cert-modal]');
      if (!dialog) return;

      var modal = new Modal(dialog);
      modal.mount();

      Array.prototype.forEach.call(section.querySelectorAll('[data-rc-cert]'), function (button) {
        button.addEventListener('click', function () {
          modal.open(button.getAttribute('data-rc-cert'), button);
        });
      });
    });
  }

  window.RCCerts = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
